/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R7Inputs */



/**
* | output |
* | --- |
* | "R7 Same seat position" |
*
* @param {Rounds_R7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r7 = /** @type {((inputs?: Rounds_R7Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R7Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R7 Même position de siège")
	if (locale === "es") return /** @type {LocalizedString} */ ("R7 Misma posición de asiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R7 Mesma posição na mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("R7 Stessa posizione")
	return /** @type {LocalizedString} */ ("R7 Same seat position")
});